<template>
    <div class="message-list">
        <div v-for="(message, index) in messages"
            :key="index"
            :class="message.mType">
            <img :src="getMessageImage(message)" v-if="isMessage(message)">
            <div class="message-body">
                <span class="message-sub-header" v-if="message.title">
                    {{ message.title }}
                </span>
                <span class="message-sub-body">
                    {{ message.text }}
                </span>
                <span v-if="!isMessage(message) && message.phone" class="message-sub-phone">
                    {{ message.phone }}
                </span>
                <MessageAttachement
                    :message="message"
                    :showData="false"
                    :patientId="patientId">
                </MessageAttachement>
                <span class="message-sub-footer">
                    <template v-if="!isMessage(message)">
                        <el-button v-if="message.status == 'open'"
                            type="text" 
                            class="ticket-close"
                            @click="markClosed(message)"
                            :disabled="updating[message.id]">
                            {{ updating[message.id] ? 'Closing...' : 'Mark Closed' }}
                        </el-button>
                        <div class="ticket-closed-status" v-else-if="message.status == 'closed'">
                            <i class="el-icon-check"></i>
                            Closed
                        </div>
                    </template>
                    
                    <span class="message-sub-date">
                        <template v-if="isMessage(message) && isHistory(message)">
                            <OpenedTickIcon v-if="message.accepted || message.opened"></OpenedTickIcon>
                            <SendTickIcon v-else></SendTickIcon>
                        </template>
                        <b> {{ formatDate(message.time) }}</b>, {{ formatTime(message.time) }}
                    </span>
                    
                </span>
                <MessageComment v-if="!isMessage(message) && message.status == 'closed'"
                    :comment="message.comment || ''"
                    :commenting="commenting[message.id] || false"
                    :comment-time="message.last_status_change || 0"
                    @add-comment="addComment($event, message)"></MessageComment>
            </div>
            
            <span v-if="!isMessage(message)" class="ticket-icon">
                {{ (patientName || '')[0] }}
            </span>
        </div>
        <div v-if="messages.length === 0">
            No scheduled messages from {{ providerName }}
        </div>
    </div>
</template>

<script>
import formatTime from '@/module/util/format-time'
import formatDate from '@/module/util/format-date'
import MessageAttachement from './Attachment'
import MessageComment from './Comment'

import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue'

import Icons from './icon'

export default {
    name: 'patient-message-card-list',

    props: {
        messages: {
            type: Array,
            required: true
        },
        patientName: {
            type: String,
            required: true
        },
        patientId: {
            type: String,
            required: true
        },
        providerName: {
            type: String
        }
    },

    data() {
        return {
            updating: {},
            commenting: {}
        }
    },
    
    computed: {
        ...mapGetters('provider', [
            'getCurrentProvider'
        ])
    },

    methods: {
        ...mapActions('provider', [
            'updatePatientTicket',
        ]),
        formatTime,
        formatDate,
        getMessageImage(message) {
            if(message.ref_type)
                return require("../image/logo.png")
            else
                return require("../image/default-doctor.png")

        },
        isMessage(message) {
            return message.mType === 'message'
        },
        isHistory(message) {
            return message.time < Date.now()
        },
        /**
         * Mark a ticket as closed from the user
         */
        markClosed(ticket) {
            const ticketData = {
                status: 'closed',
                id: ticket.id,
                patient: this.patientId
            }
            console.log(ticket)
            if(!this.getCurrentProvider)
                ticketData.provider = ticket.provider.split(':')[0]
            Vue.set(this.updating, ticket.id, true)
            return this.updatePatientTicket(ticketData)
                .then((responseMessage) => {
                    Vue.set(ticket, 'status', responseMessage.status)
                    Vue.set(this.updating, ticket.id, false)
                })
                .catch((error) => {
                    Vue.set(this.updating, ticket.id, false)
                    throw error
                })
        },
        addComment(userComment, ticket) {
            const ticketData = {
                status: ticket.status,
                id: ticket.id,
                patient: this.patientId,
                comment: userComment
            }
            if(!this.getCurrentProvider)
                ticketData.provider = ticket.provider.split(':')[0]
            Vue.set(this.commenting, ticket.id, true)
            return this.updatePatientTicket(ticketData)
                .then((responseMessage) => {
                    Vue.set(ticket, 'comment', responseMessage.comment)
                    Vue.set(ticket, 'last_status_change', responseMessage.last_status_change)
                    Vue.set(this.commenting, ticket.id, false)
                })
                .catch((error) => {
                    Vue.set(this.commenting, ticket.id, false)
                    throw error
                })
        },
    },



    components: {
        MessageAttachement,
        MessageComment,
        ...Icons
    }
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
